import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/lib/queryClient';
import { dashboardApi, mockDashboardData } from '../api/dashboard.api';
import { APP_CONFIG } from '@/constants/config';

export function useDashboardStats() {
  return useQuery({
    queryKey: queryKeys.dashboard.stats(),
    queryFn: async () => {
      if (APP_CONFIG.enableMockData) {
        // Simulate API delay
        await new Promise((resolve) => setTimeout(resolve, 500));
        return mockDashboardData.stats;
      }
      return dashboardApi.getStats();
    },
    staleTime: 60 * 1000, // 1 minute
  });
}

export function useDashboardCharts() {
  return useQuery({
    queryKey: ['dashboard', 'analytics'],
    queryFn: async () => {
      if (APP_CONFIG.enableMockData) {
        await new Promise((resolve) => setTimeout(resolve, 500));
        return mockDashboardData.chartData;
      }
      return dashboardApi.getAnalytics();
    },
    staleTime: 60 * 1000,
  });
}

export function useRecentBookings() {
  return useQuery({
    queryKey: queryKeys.dashboard.recentBookings(),
    queryFn: async () => {
      if (APP_CONFIG.enableMockData) {
        await new Promise((resolve) => setTimeout(resolve, 500));
        return mockDashboardData.recentBookings;
      }
      return dashboardApi.getRecentBookings();
    },
    staleTime: 30 * 1000, // 30 seconds
  });
}

export function useCityAnalytics() {
  return useQuery({
    queryKey: ['dashboard', 'city-analytics'],
    queryFn: async () => {
      if (APP_CONFIG.enableMockData) {
        await new Promise((resolve) => setTimeout(resolve, 500));
        return mockDashboardData.cityWiseData;
      }
      return dashboardApi.getCityAnalytics();
    },
    staleTime: 60 * 1000,
  });
}

export function usePayoutBalance() {
  return useQuery({
    queryKey: ['admin', 'payouts-balance'],
    queryFn: () => dashboardApi.getPayoutBalance(),
    staleTime: 60 * 1000, // 1 minute
  });
}
